import { Link } from "react-router-dom";

export const AuthCard = ({ title, subtitle, children, testid }) => (
  <div className="min-h-screen bg-canvas text-white grain grid place-items-center px-6" data-testid={testid}>
    <div className="w-full max-w-md">
      <Link to="/" className="flex flex-col items-center gap-3 mb-8" data-testid="auth-logo-link">
        <img src="/logo.webp" alt="AEGIS Guard logo" className="w-36 h-36 object-contain drop-shadow-[0_0_30px_rgba(56,189,248,0.35)]" />
      </Link>
      <div className="border border-white/10 bg-white/[0.02] backdrop-blur-xl p-8 rise">
        <h1 className="font-mono text-2xl font-extrabold tracking-tight">{title}</h1>
        {subtitle && <p className="text-sm text-white/55 mt-2">{subtitle}</p>}
        <div className="mt-6">{children}</div>
      </div>
    </div>
  </div>
);

export const Field = ({ label, testid, ...props }) => (
  <label className="block mb-4">
    <span className="label-xs">{label}</span>
    <input {...props} data-testid={testid}
      className="mt-1.5 w-full bg-field border border-fieldline px-3 py-2.5 text-sm focus:outline-none focus:border-brand transition-colors" />
  </label>
);

export const SubmitBtn = ({ busy, children, testid }) => (
  <button type="submit" disabled={busy} data-testid={testid}
    className="w-full py-3 bg-brand text-black font-mono text-xs font-bold tracking-[0.18em] hover:shadow-[0_0_28px_rgb(var(--brand-rgb)/0.4)] transition-shadow disabled:opacity-50">
    {busy ? "WORKING…" : children}
  </button>
);

export const FormError = ({ error }) => error ? <p className="text-sm text-[#F87171] mb-4" data-testid="auth-error">{error}</p> : null;
